import { render, staticRenderFns } from "./readPeopleModal.vue?vue&type=template&id=8545e950&scoped=true&"
import script from "./readPeopleModal.vue?vue&type=script&lang=js&"
export * from "./readPeopleModal.vue?vue&type=script&lang=js&"
import style0 from "./readPeopleModal.vue?vue&type=style&index=0&id=8545e950&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8545e950",
  null
  
)

export default component.exports